import HttpService from './HttpService';

const PassengerApi = HttpService('/api/passengers/');
const doGet = (url) => PassengerApi.get(url);
const doPost = (action, data) => PassengerApi.post(action, data);
const doPut = (action, data) => PassengerApi.put(action, data);
const doDelete = (url) => PassengerApi.delete(url);

export default {
  getPassengersForVoyage(voyageReportId) {
    const queryString = `voyageReportId=${voyageReportId}`;
    const apiAction = 'GetPassengersForVoyage';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  createPassenger(passenger) {
    const apiAction = 'CreatePassenger';
    return doPost(apiAction, passenger);
  },
  updatePassenger(updatedPassenger) {
    const apiAction = 'UpdatePassenger';
    return doPut(apiAction, updatedPassenger);
  },
  deletePassenger(id) {
    const apiAction = 'DeletePassenger';
    const queryString = `id=${id}`;
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doDelete(fullUrl);
  },
};
